export default __webpack_public_path__ + "static/media/choose-animate.797254e2.svg";